export default class AccountSwitcherService {
  constructor(leanLawAuth, http) {
    this.leanLawAuth = leanLawAuth;
    this.http = http;
  }
  switchFirm(account, redirect) {
    const domain = this.domain;
    const accountIdParam = `accountId=${account.id}`;
    const returnUrlParam = this._getReturnUrlParam(redirect);
    const url = `${domain}/Account/Change?${accountIdParam}${returnUrlParam}`;
    // Account/Change sets the auth cookie and 302s to returnUrl. This MUST be a full-page
    // navigation, not an XHR: a credentialed XHR can't follow the cross-origin 302 back to the
    // SPA (CORS-blocked, reported as status -1), so the switch would never complete. (sc-46139)
    window.location.href = url;
  }
  _getReturnUrlParam(redirect) {
    if (redirect) {
      return `&returnUrl=${encodeURIComponent(redirect)}`;
    }
    return '';
  }
  get domain() {
    return this.leanLawAuth.domain;
  }
}